import script from "./SigninDesktop.vue?vue&type=script&setup=true&lang=js"
export * from "./SigninDesktop.vue?vue&type=script&setup=true&lang=js"

import "./SigninDesktop.vue?vue&type=style&index=0&id=90864384&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90864384"]])

export default __exports__